export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.a93f2b75ae93d85fd546.worker.js");
}
